import React from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import frLocale from 'date-fns/locale/fr';
import esLocale from 'date-fns/locale/es';
import enLocale from 'date-fns/locale/en-US';
import deLocale from 'date-fns/locale/de';
import './dateRangeFilter.scss';
import { capitalizeSentence } from '../../../../utils/usefulFunctions';
import { styled } from '@mui/material';
import { getCSSVariable } from '../../../../stylesheets/cssVariablesUtils';
import useTranslate from '../../../../customHooks/useTranslate';
import useLanguage from '../../../../customHooks/useLanguage';

const DateRangeFilter = ({
    value,
    onChange: handleChange,
    nameFrom,
    nameTo,
    label,
    fromInputProps,
    toInputProps,
    ...restProps
}) => {
    const translate = useTranslate();
    const language = useLanguage();

    const languageSettings = {
        en: { locale: enLocale },
        fr: { locale: frLocale },
        es: { locale: esLocale },
        de: { locale: deLocale },
    };
    const locale = languageSettings[language].locale;

    const startText = `${capitalizeSentence(translate(label))} ${translate(
        'from'
    )}`;
    const endText = translate('to');

    const [valueFrom, valueTo] = value;

    const handleFromChange = newValue => {
        handleChange([
            { nameFrom, valueFrom: newValue },
            { nameTo, valueTo },
        ]);
    };

    const handleToChange = newValue => {
        handleChange([
            { nameFrom, valueFrom },
            { nameTo, valueTo: newValue },
        ]);
    };

    // Componente estilizado
    const StyledTextField = styled(TextField)({
        '& label.Mui-focused': {
            color: getCSSVariable('jungleGreen'),
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: getCSSVariable('jungleGreen'),
            },
            '&.Mui-focused fieldset': {
                borderColor: getCSSVariable('jungleGreen'),
            },
        },
    });

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale}>
            <div style={{ display: 'flex' }}>
                <DatePicker
                    slotProps={{ textField: { size: 'small' } }}
                    label={startText}
                    value={valueFrom}
                    onChange={handleFromChange}
                    renderInput={params => (
                        <StyledTextField
                            {...params}
                            autoComplete='off'
                            {...fromInputProps}
                        />
                    )}
                    {...restProps}
                />
                <DatePicker
                    slotProps={{ textField: { size: 'small' } }}
                    label={endText}
                    value={valueTo}
                    onChange={handleToChange}
                    renderInput={params => (
                        <StyledTextField
                            {...params}
                            autoComplete='off'
                            {...toInputProps}
                        />
                    )}
                    {...restProps}
                />
            </div>
        </LocalizationProvider>
    );
};

export default DateRangeFilter;
